export default {
  gray: {
    800: "#202125",
  },
};
